module.exports = __webpack_public_path__ + "img/Documento_Firma.337cabf8.svg";